import { motion } from "framer-motion-3d"
import { useContext } from "react"

import { buildings, colors } from "../../../helpers/constants"
import AppContext from "../../../hooks/AppConext"
import { useColor } from "../../../hooks/useColor"
import { StateWrapper } from "../StateWrapper"

const Material = ({ name }) => {
  const { color } = useColor(name)

  return (
    <meshPhongMaterial
      flatShading
      toneMapped={false}
      specular="#fff"
      emissive="#000"
      color={color}
      shininess={5}
      transparent
    />
  )
}

const ModernRoof = ({ nodes }) => {
  const { hovered, selected, menuHovered } = useContext(AppContext)
  const { color } = useColor("modern")

  return (
    <mesh
      geometry={nodes["Roof"].geometry}
      name="modern"
      position={buildings["modern-roof"].position}
    >
      <motion.meshPhongMaterial
        flatShading
        specular="#fff"
        emissive="#000"
        color={
          [hovered, menuHovered, selected].includes("modern")
            ? color
            : colors["modern-roof"]
        }
        transparent
        animate={
          [hovered, menuHovered].includes("dome")
            ? { opacity: 0 }
            : { opacity: 1 }
        }
        shininess={5}
        transition={{
          type: "spring",
          bounce: 0,
        }}
      />
    </mesh>
  )
}

export const Modern = ({ nodes }) => {
  return (
    <StateWrapper name="modern">
      <mesh
        geometry={nodes["B2"].geometry}
        position={buildings["modern"].position}
        name="modern"
      >
        <Material name="modern" />
      </mesh>
      <ModernRoof nodes={nodes} />
    </StateWrapper>
  )
}
